import type { RestAvailableBillingItem } from "@KassaroAB/shared/types/availableBillingItem";
import { api } from "../utils/api";
import type {
  ResellerId,
} from "@KassaroAB/shared/types/ids";
import type { ResellerAvailableBillingItem, RestCreateResellerAvailableBillingItem, RestUpdateResellerAvailableBillingItem } from "@KassaroAB/shared/types/resellerAvailableBillingItem";


export const getResellerAvailableBillingItemsApi = async (
  resellerId: ResellerId,
): Promise<RestAvailableBillingItem[]> => {
  return api.get(`resellers/${resellerId}/availableBillingItems`);
};

export const setResellerAvailableBillingItemsApi = async (
  resellerId: ResellerId,
  items: RestCreateResellerAvailableBillingItem[],
): Promise<RestAvailableBillingItem[]> => {
  return api.put(`resellers/${resellerId}/availableBillingItems`, { items });
};

export const getResellerAvailableBillingItemApi = async (
  resellerId: ResellerId,
  resellerAvailableBillingItemId: string,
): Promise<RestAvailableBillingItem> => {
  return api.get(`resellers/${resellerId}/availableBillingItems/${resellerAvailableBillingItemId}`);
};

export const createResellerAvailableBillingItemApi = async (
  resellerId: ResellerId,
  data: RestCreateResellerAvailableBillingItem,
): Promise<ResellerAvailableBillingItem> => {
  return api.post(`resellers/${resellerId}/availableBillingItems`, data);
};

export const updateResellerAvailableBillingItemApi = async (
  resellerId: ResellerId,
  resellerAvailableBillingItemId: string,
  data: RestUpdateResellerAvailableBillingItem,
): Promise<ResellerAvailableBillingItem> => {
  return api.patch(`resellers/${resellerId}/availableBillingItems/${resellerAvailableBillingItemId}`, data);
};

export const deleteResellerAvailableBillingItemApi = async (
  resellerId: ResellerId,
  resellerAvailableBillingItemId: string,
): Promise<void> => {
  return api.delete(`resellers/${resellerId}/availableBillingItems/${resellerAvailableBillingItemId}`);
};
